<template>
  <span :title="absoluteAge">{{ relativeAge }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { flowingTime } from '../services/dateTime';
import dayjs from 'dayjs';

const props = defineProps({
  at: { type: String, required: false },
  withoutSuffix: { type: Boolean, default: false },
  useSince: { type: Boolean, default: false },
});

const i18n = useI18n();

const relativeAge = computed(() => {
  if (props.at) {
    if (props.useSince) {
      const currentLocale = dayjs.locale();
      const sinceLocaleName = `${currentLocale}-since`;
      return dayjs(props.at).locale(sinceLocaleName).from(flowingTime.value, props.withoutSuffix);
    }
    return dayjs(props.at).from(flowingTime.value, props.withoutSuffix);
  }
  return '';
});

const absoluteAge = computed(() => {
  if (props.at) {
    return i18n.d(props.at, 'dtshort').toString();
  }
  return '';
});
</script>
